import { render } from "./SubscriptionsView.vue?vue&type=template&id=4bc40078"
import script from "./SubscriptionsView.vue?vue&type=script&lang=js"
export * from "./SubscriptionsView.vue?vue&type=script&lang=js"

import "./SubscriptionsView.vue?vue&type=style&index=0&id=4bc40078&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__